import React from 'react'
import { AppAuthProviderContextValue } from '../types'

export const AppAuthContext = React.createContext<AppAuthProviderContextValue>({
    isAuthenticated: false,
})
